var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass: "list-supplier-item ",
      staticStyle: { "list-style-type": "none" },
    },
    [
      _c("div", { staticClass: "d-flex align-items-center" }, [
        _c("div", [
          _c("img", {
            staticClass: "round",
            attrs: {
              src:
                _vm.member.avatar !== null
                  ? _vm.member.avatar.url
                  : "/images/avatar.png",
              alt: "avatar",
              height: "25",
              width: "25",
            },
          }),
        ]),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("span", { staticClass: "font-weight-bold ml-05 mb-0 mt-1" }, [
              _vm._v(
                _vm._s(_vm.member.first_name) +
                  " " +
                  _vm._s(_vm.member.last_name)
              ),
            ]),
            _vm._v(" "),
            _vm._l(_vm.member.badges, function (badge) {
              return _c("span", [
                _c("img", {
                  staticStyle: { "margin-top": "-3px", height: "12px" },
                  attrs: {
                    src: badge.image,
                    "data-toggle": "tooltip",
                    "data-placement": "bottom",
                    title: badge.name,
                    alt: "badge image",
                  },
                }),
              ])
            }),
            _vm._v(" "),
            _vm.member.user_badge_name !== null &&
            _vm.member.user_badge_icon !== null
              ? _c("img", {
                  staticStyle: { "margin-top": "-3px", height: "12px" },
                  attrs: {
                    src: _vm.member.user_badge_image.url,
                    "data-toggle": "tooltip",
                    "data-placement": "bottom",
                    title: _vm.member.user_badge_name,
                    alt: "badge image",
                  },
                })
              : _vm._e(),
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "ml-auto" }, [
          _vm.siteAdmin || _vm.admins.includes(_vm.userId)
            ? _c("div", { staticClass: "d-flex" }, [
                _c(
                  "div",
                  { staticClass: "pr-05" },
                  [
                    _c(
                      "admin",
                      {
                        attrs: {
                          type: _vm.type,
                          slug: _vm.slug,
                          member: _vm.member,
                          is_admin: _vm.admins.includes(_vm.member.id),
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            attrs: { slot: "buttons_make_admin" },
                            slot: "buttons_make_admin",
                          },
                          [_vm._t("buttons_make_admin")],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            attrs: { slot: "buttons_admin" },
                            slot: "buttons_admin",
                          },
                          [_vm._t("buttons_admin")],
                          2
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("manage-followers", {
                      attrs: {
                        type: _vm.type,
                        slug: _vm.slug,
                        member: _vm.member,
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }